import { connect } from 'react-redux'
import { useState, useRef, useEffect } from 'react';
import EmojiPicker from 'emoji-picker-react';
import {
    ActionIcon,
    ScrollArea,
    Avatar,
    Collapse,
    Tooltip,
    Group,
    Loader,
    Menu,
    Stack,
    Textarea,
    Flex,
    CloseButton
} from "@mantine/core";
import { IconArrowBadgeRightFilled, IconMoodTongue} from '@tabler/icons-react';

import ChatMessage from "./ChatMessage.jsx"
import{__} from "../../traslates/blabla"

let ChatDialog = (props) => {
    
    const [chatText, setChatText] = useState("")
    const [emoties, setEmoties] = useState(false)
    const [scrollable, setScrollable] = useState(false)
    const endRef = useRef(null)
    
    /*const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach(entry => {
            if(props.onMessageVue){
                if (entry.isIntersecting) {
                    props.onMessageVue(entry.target.id.replace("chat-message-", ""), true)
                  } else {
                    props.onMessageVue(entry.target.id.replace("chat-message-", ""), false)
                  }

            }
            
          });
        },
        {
          root: null, // null = viewport
          threshold: 0.1 // visible si au moins 10% de l’élément apparaît
        }
    );*/

    useEffect(() => {
        if (endRef.current) {
            endRef.current.scrollIntoView({ behavior: 'smooth' })
        }
    }, [props.messages])

    setTimeout(()=>{
        if (endRef.current) {
            endRef.current.scrollIntoView({ behavior: 'smooth' })
        }
        /*setTimeout(()=>{
            //setScrollable(true)
            (props.messages || []).map((msg) => {
                const target = document.getElementById(`chat-message-${msg.id}`);
                observer.observe(target);
            })


        }, 200)*/
    }, 200)
    
    return (
        <Stack className='chatDialog' p={0} spacing={0} m={0}>
            <ScrollArea h={"calc(4*2rem)"} onScrollPositionChange={({ x, y }) => {
                if(scrollable){ 
                    console.log('ChatDialog ScrollArea', x, y);
                }
            }}>
                
                    {
                        (props.messages || []).map((msg, position) => (
                            <div id={`chat-message-${msg.id}`}>
                                <ChatMessage key={position} message={msg} />
                            </div>
                        ))
                    }
                    <div ref={endRef} /> 
                
            </ScrollArea>
             <Group className='text' justify="left">
                <Flex className='area' >
                    <Textarea id="chat-dialog-textarea" className='textarea' value={chatText}
                        placeholder={__("Entrez votre text")}
                        autosize
                        minRows={2}
                        onInput={(e)=>{setChatText(e.target.value)}}
                    />
                     <ActionIcon className='bt-emoties' variant="transparent" size="lg" onClick={()=>{
                        setEmoties(true)
                    }}><IconMoodTongue size={24} /></ActionIcon>
                        {emoties?(
                            <div className="emoties">
                                <CloseButton className="close"onClick={(e)=>{
                                    setEmoties(false)
                                }}/>
                                <EmojiPicker open={emoties} onEmojiClick={(e)=>{
                                    const textarea = document.getElementById("chat-dialog-textarea");

                                    // Position du curseur
                                    const start = textarea.selectionStart;
                                    const end   = textarea.selectionEnd;
                                    const currentText = textarea.value;
                                    
                                    const tstart = currentText.substring(0, start)
                                    const tend = currentText.substring(end)

                                    textarea.value = tstart + e.emoji + tend;
                                    const newPos = start + e.emoji.length;
                                    textarea.selectionStart = textarea.selectionEnd = newPos;
                                    setChatText(textarea.value)
                                    setTimeout(()=>{
                                        setEmoties(false)
                                    }, 10)
                                    
                                }}/>
                            </div>
                        ):""}
                    
                </Flex>
                <ActionIcon className='go' onClick={()=>{
                    if(props.onSendMessage){
                        props.onSendMessage(chatText)
                        setTimeout(()=>{
                            setChatText("")
                        }, 10)
                    }
                }}><IconArrowBadgeRightFilled size={14} /></ActionIcon>
            </Group>
            
            

        </Stack>
    )
}



const mapDispatchToProps = {
    
}


const mapStateToProps = (state) => {  
    return {
        notification: state ? state.notification : undefined,
    
    }
}


ChatDialog = connect(mapStateToProps, mapDispatchToProps)(ChatDialog);

export default ChatDialog;